// Attendance actions (mark from client card) — типизированные обёртки.
//
// Контракт сверен напрямую с backend-контроллером:
//   - POST /api/v1/attendance            (attendance.controller → MarkAttendanceSchema)
//
// Списком занятий эта прослойка больше не занимается: с батча №12 (Ф6) он
// приходит из schedule-хука useOccurrences в формате расписания. Здесь остались
// отметка и тип OccurrenceItem — им типизируется правило окна (isMarkable).
//
// Минимальное тело mark-attendance: { client_id, occurrence_id, status:'attended' }.
// subscription_id / entitlement_id опциональны — при status='attended' backend
// сам подбирает подходящий Subscription+Entitlement (см. MarkAttendanceCommand
// §4 + EntitlementResolverService). Если у клиента нет применимого абонемента,
// backend вернёт 422 attendance.no_entitlement — показываем как ошибку формы.

import { api } from '@/lib/api';

// --- Занятие (минимум полей для правила окна отметки) -----------------------

export type OccurrenceStatus = 'scheduled' | 'completed' | 'cancelled' | 'moved';

export interface OccurrenceItem {
  id: string;
  seriesId: string | null;
  groupId: string;
  branchId: string;
  hallId: string;
  teacherId: string;
  scheduledAt: string;
  durationMinutes: number;
  maxAttendees: number;
  status: OccurrenceStatus;
}

// --- Mark attendance --------------------------------------------------------
// Сверено с MarkAttendanceSchema (attendance.dto.ts).

export type MarkAttendanceStatus = 'scheduled' | 'attended' | 'no_show' | 'cancelled';

export interface MarkAttendanceBody {
  client_id: string;
  occurrence_id: string;
  status: MarkAttendanceStatus;
  subscription_id?: string;
  entitlement_id?: string;
  comment?: string;
}

/**
 * POST /api/v1/attendance — ручная отметка из карточки клиента.
 * Возвращаемое тело различается (ScanCardResult | { attendance }); нам важен
 * только факт успеха, поэтому типизируем как unknown.
 */
export function markAttendance(body: MarkAttendanceBody): Promise<unknown> {
  return api.post<unknown>('/attendance', body);
}
